import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export const MiscColorWheelIcon = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ _jsx("svg", {
        ref: ref,
        ...props,
        viewBox: "0 0 32 32",
        children: /*#__PURE__*/ _jsx("g", {
            transform: "rotate(90 0 16) scale(.016)",
            children: /*#__PURE__*/ _jsx("foreignObject", {
                width: "2000",
                height: "2000",
                x: "-1000",
                y: "-1000",
                children: /*#__PURE__*/ _jsx("div", {
                    style: {
                        background: "conic-gradient(from 90deg,red 0deg,#ff7f00 57.6deg,#ff0 118.8deg,#0f0 180deg,#0ff 237.6deg,#00f 298.8deg,#8b00ff 327.6deg,red 360deg)",
                        height: "100%",
                        width: "100%",
                        borderRadius: "100%"
                    }
                })
            })
        })
    }));
MiscColorWheelIcon.displayName = "MiscColorWheelIcon";
